module.exports = __webpack_public_path__ + "static/img/hairloss_02.ab90f6a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/c11/hairloss_02.jpg
// module id = wqjs
// module chunks = 0